module.exports = __webpack_public_path__ + "img/banner_2.e46a1882.jpg";